import React from 'react'
import PPVTemplate from 'src/components/page/ppv'
import { commonCtaText } from 'src/modules/utils/constants'
import styled from 'styled-components'

export default (props) => {
  return (
    <StyledContainer>
      <PPVTemplate
        lang="en"
        market="us"
        location={props.location}
        title="AEW: WrestleDream 2025"
        subtitle="Watch live this Saturday, October 18, on Fubo Pay Per View."
        video={
          'https://assets.fubo.tv/marketing/lp/videos/compressed/PPV_AEW_WrestleDream_16x9_3Mb.mp4'
        }
        videoMobile={
          'https://assets.fubo.tv/marketing/lp/videos/mobile/PPV_AEW_WrestleDream_1x1_3Mb.mp4'
        }
        additionalFAQs={additionalFAQs}
        isEventEnded={true}
        ctaText={commonCtaText.getStarted}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .content-container .hero-content {
    max-width: 670px;
  }
`

const additionalFAQs = [
  {
    question: 'Can I watch AEW WrestleDream 2025 on Fubo?',
    answer:
      'Yes, you can watch AEW WrestleDream 2025 on Fubo. It is available as a Pay Per View event. A Fubo subscription is not required to order the Pay Per View.',
  },
  {
    question: 'How do I find AEW WrestleDream 2025 on Fubo?',
    answer:
      'If you ordered the AEW WrestleDream 2025 Pay Per View event, type “pay per view” in Fubo’s search bar or find the Pay Per View channels in the channel guide.',
  },
  {
    question: 'Can I watch AEW commentary and analysis on Fubo?',
    answer:
      'Yes, if you order the AEW Pay Per View you will have access to the Pay Per View preshow and other content. Get all the storyline updates, interviews and analysis you’ll need before the event.',
  },
  {
    question: 'Will AEW WrestleDream 2025 be replayed on Fubo?',
    answer:
      'Yes, if you miss the event or want to watch it again, AEW WrestleDream 2025 will be available to replay for a period of time after the event ends.',
  },
  {
    question: 'What related AEW content can I find on Fubo?',
    answer:
      'If you like AEW, you’ll love the variety of pro wrestling, boxing and other combat sports on Fubo. With a Fubo subscription you can watch WWE, UFC, BKFC and more. Plus behind-the-scenes shows and special events for fans of every sport and league.',
  },
]
